import { getRangeInlineNodeNames } from '@atlaskit/editor-common/utils';
import { fg } from '@atlaskit/platform-feature-flags';
export function getRendererRangeInlineNodeNames({
  actions,
  pos
}) {
  if (!fg('editor_inline_comments_on_inline_nodes')) {
    return undefined;
  }
  const {
    doc
  } = actions;
  if (!pos || !doc) {
    return undefined;
  }
  const inlineNodeNames = getRangeInlineNodeNames({
    doc,
    pos
  });
  return inlineNodeNames;
}